import baseStyles from '../Base/Base.styles'
import merge from 'lodash/merge'
import BaseImageStyles from '../BaseImage/BaseImage.styles'

export default properties => {
  const { 
    layout, 
    base, 
    background
  } = properties

  let jss = {
    root: {
      ...baseStyles(base),
      '& .surface': {
        display: 'grid',
        position: 'relative',
        gridAutoFlow: 'dense',
        borderRadius: 'var(--themeShape)',
        background: background
      }
    }
  }

  if (layout == 'image-left') {
    jss = merge(jss, {
      root: {
        '& .surface': {
          gridTemplateColumns: '1fr 2fr',
        },
        '& .quote-image': { 
          gridColumn: 1
         },
        '& .quote-image .image': { 
          borderRadius: 'var(--themeShape) 0 0 var(--themeShape)'
         },
        '& .quote-content': { 
          gridColumn: 2
        }
      } 
    })
  }

  if (layout == 'image-right') {
    jss = merge(jss, {
      root: {
        '& .surface': {
          gridTemplateColumns: '2fr 1fr',
        },
        '& .quote-image': { 
          gridColumn: 2
         },
        '& .quote-image .image': { 
          borderRadius: '0 var(--themeShape) var(--themeShape) 0'
         },
        '& .quote-content': { 
          gridColumn: 1,
        }
      } 
    })
  }

  if (layout == 'image-top') {
    jss = merge(jss, {
      root: {
        '& .surface': {
          display: 'block'
        },
        '& .quote-image .image': {
          height: '400px',
          borderRadius: 'var(--themeShape) var(--themeShape) 0 0'
        }
      } 
    })
  }

  jss = merge(jss, {
    root: {
      '& .quote-content': {
        position: 'relative',
        padding: '30px 40px',
        overflow: 'hidden'
      },
      '& .quote-image .image': {
        width: '100%',
        height: '100%',
        objectFit: 'cover'
      }
    }
  }) 

  if (background) {
    jss = merge(jss, {
      root: {
        '& .surface': { background }
      } 
    })
  }

  jss = merge(jss, {
    root: {
      '& .surface': {
        '@media (max-width: 720px)': {
          display: 'block'
        }
      },
      '& .surface .quote-image .image': {
        '@media (max-width: 720px)': {
          borderRadius: 'var(--themeShape) var(--themeShape) 0 0'
        }
      }
    } 
  })

  return jss
}
